import React, { useEffect } from "react";
import "./My_Orders.css";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { Button } from "react-bootstrap";
import OrderCard from "../common_components/order_card/OrderCard";
import { useNavigate } from "react-router-dom";
import Common_Back_Header from "../common_components/common_back_header/Common_Back_Header";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCancelledOrder,
  getAllOrder,
  getAllOrderDeliver,
  GetallRejectedOrders,
  getAllReturnedOrder,
} from "../../features/order/orderSlice";
import { encodeId, formatDate } from "../../utils/common";

const My_Orders = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const orders = useSelector((state) => state.order.allOrders);
  useEffect(() => {
    dispatch(getAllOrder({ order_status_id: [1, 2, 3, 4] }));
  }, [dispatch]);

  const deliver = useSelector((state) => state.order.allOrdersDeliver);
  useEffect(() => {
    dispatch(getAllOrderDeliver({ order_status_id: [5] }));
  }, [dispatch]);

  const rejected = useSelector((state) => state.order.allRejectedOrders);
  useEffect(() => {
    dispatch(GetallRejectedOrders({ order_status_id: [6] }));
  }, [dispatch]);

  const returnedOrders = useSelector((state) => state.order.allReturnedOrders);
  useEffect(() => {
    dispatch(getAllReturnedOrder({ order_status_id: 7 }));
  }, [dispatch]);

  const cancelledOrders = useSelector(
    (state) => state.order.allCancelledOrders
  );
  useEffect(() => {
    dispatch(getAllCancelledOrder({ order_status_id: 6 }));
  }, [dispatch]);


  

  return (
    <section className="My_Orders">
      <div className="container">
        <Common_Back_Header backNavigation="/my-profile" />

        <div className="action_tab_section">
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <Nav variant="pills" className="">
                  <Nav.Item>
                    <Nav.Link eventKey="first">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/img1.png"
                          }
                        />
                      </div>

                      <span className="tab_text">Ordered</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="second">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/img2.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Delivered</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="third">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/img3.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Cancelled</span>
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link eventKey="fifth">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/img3.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Rejected</span>
                    </Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                    <Nav.Link eventKey="fourth">
                      <div className="img_holder">
                        <img
                          className="tab_icon"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/my_order/img3.png"
                          }
                        />
                      </div>
                      <span className="tab_text">Returned</span>
                    </Nav.Link>
                  </Nav.Item> */}

                  {/* <Nav.Item>
                                        <Nav.Link eventKey="fourth">
                                            <div className='img_holder'>
                                                <img
                                                    className='tab_icon'
                                                    src={
                                                        process.env.PUBLIC_URL +
                                                        "/assets/images/my_order/img3.png"
                                                    }
                                                />
                                            </div>
                                            <span className='tab_text'>Returned</span></Nav.Link>
                                    </Nav.Item> */}
                </Nav>
              </div>

              <div className="col-lg-9 col-md-8">
                <div className="">
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <div className="">
                        {orders?.data?.map((order) => (
                          <OrderCard
                            navigate={`/order-details/${order?.id}`}
                            title={order?.Product_Order_Details?.Product?.name}
                            showtracking
                            footer_text_color="#D60000"
                            img={order?.Product_Order_Details?.Product?.image}
                            orderId={order?.invoice_no}
                            items={`${order?.no_of_item} Items`}
                            kwd={Number(order?.total_amount || 0).toFixed(2)}
                            footer_text={order?.Order_status?.name}
                            date={formatDate(order?.createdAt)}
                            order={order}
                            trackingText="Order Return Tracking"
                          />
                        ))}
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="second">
                      <div className="">
                        {deliver?.data?.map((order) => (
                          <OrderCard
                            navigate={`/delivered-order/${order?.id}`}
                            title={order?.Product_Order_Details?.Product?.name}
                            showtracking
                            footer_text_color="#D60000"
                            img={order?.Product_Order_Details?.Product?.image}
                            orderId={order?.invoice_no}
                            items={`${order?.no_of_item} Items`}
                            kwd={Number(order?.total_amount || 0).toFixed(2)}
                            footer_text={order?.Order_status?.name}
                            date={formatDate(order?.createdAt)}
                            order={order}
                            trackingText="Order Return Tracking"
                          />
                        ))}
                        {/* <OrderCard navigate="/delivered-order" title="ScanMart Grocery" footer_text_color="#D60000" img="/assets/images/profile/myaccount/img1.png" orderId="Order ID #675843" items="2 Items" kwd="Rs.: 200" footer_text="Delivering in 10 mins" date="27th Oct. | 03:28 pm" />
                                                <OrderCard navigate="/delivered-order" title="ScanMart Grocery" footer_text_color="#D60000" img="/assets/images/profile/myaccount/img1.png" orderId="Order ID #675843" items="2 Items" kwd="Rs.: 200" footer_text="Delivering in 10 mins" date="27th Oct. | 03:28 pm" /> */}
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="fifth">
                      <div className="">
                        {rejected?.data?.map((order) => (
                          <OrderCard
                            navigate={`/delivered-order/${order?.id}?status=Rejected`}
                            title={order?.Product_Order_Details?.Product?.name}
                            // showtracking
                            footer_text_color="#D60000"
                            img={order?.Product_Order_Details?.Product?.image}
                            orderId={order?.invoice_no }
                            items={`${order?.no_of_item} Items`}
                            kwd={Number(order?.total_amount || 0).toFixed(2)}
                            footer_text={order?.Order_status?.name}
                            date={formatDate(order?.createdAt)}
                            order={order}
                            // trackingText="Order Return Tracking"
                          />
                        ))}
                        {/* <OrderCard navigate="/delivered-order" title="ScanMart Grocery" footer_text_color="#D60000" img="/assets/images/profile/myaccount/img1.png" orderId="Order ID #675843" items="2 Items" kwd="Rs.: 200" footer_text="Delivering in 10 mins" date="27th Oct. | 03:28 pm" />
                                                <OrderCard navigate="/delivered-order" title="ScanMart Grocery" footer_text_color="#D60000" img="/assets/images/profile/myaccount/img1.png" orderId="Order ID #675843" items="2 Items" kwd="Rs.: 200" footer_text="Delivering in 10 mins" date="27th Oct. | 03:28 pm" /> */}
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey="third">
                      <div className="">
                        {cancelledOrders?.data?.map((order) => (
                          // (order?.order_status_id === 6) ?
                          <>
                            <OrderCard
                              navigate={`/cancel-order-details/${order?.id}`}
                              title={order?.Product_Variant?.Product?.name}
                              img={order?.Product?.image}
                              orderId={order?.Product_Order?.invoice_no}
                              items={`${1} Items`}
                              kwd={Number(order?.total_amount || 0).toFixed(2)}
                              footer_text={`Cancelled on ${formatDate(
                                order?.Product_Order?.updatedAt
                              )}`}
                              footer_text_color="#EC353A"
                              date={formatDate(order?.createdAt)}
                              showtracking
                              //   trackingText="Order Return Tracking"
                              order={order}
                            />
                          </>
                          // : <>
                          // </>
                          /*: <>*/
                          /*: <>*/
                          /*: <>*/
                          /*: <>*/
                          /*: <>*/
                          /*: <>*/
                         /*: <>*/))}
                        {/* <OrderCard navigate={`/order-details/${order?.id}`} title={order?.Product_Order_Details?.Product?.name
                                                } showtracking footer_text_color="#D60000"
                                                    img={order?.Product_Order_Details?.Product?.image} orderId={order?.invoice_no} items={order?.no_of_item} kwd={order?.total_amount}
                                                    footer_text={order?.Order_status?.name} date={order?.createdAt} order={order} /> */}
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="fourth">
                      <div className="">
                        {returnedOrders?.data?.map((order) => (
                          // (order?.order_status_id >= 7) ?
                          <OrderCard
                            navigate={`/return-order-details/${order?.id}`}
                            title={order?.Product_Variant?.Product?.name}
                            img={order?.Product?.image}
                            orderId={order?.Product_Order?.invoice_no}
                            items={`${order?.no_of_item} Items`}
                            kwd={Number(order?.total_amount || 0).toFixed(2)}
                            footer_text={`Returned on ${formatDate(
                              order?.Product_Order?.Order_status?.updatedAt
                            )}`}
                            footer_text_color="#EC353A"
                            date={formatDate(order?.createdAt)}
                            showtracking
                            trackingText="Order Return Tracking"
                            order={order}
                            type="Return"
                          />
                          // : <>
                          // </>
                          /*: <>*/
                          /*: <>*/
                          /*: <>*/
                          /*: <>*/
                          /*: <>*/
                          /*: <>*/
                         /*: <>*/))}
                        {/* <OrderCard navigate={`/order-details/${order?.id}`} title={order?.Product_Order_Details?.Product?.name
                                                } showtracking footer_text_color="#D60000"
                                                    img={order?.Product_Order_Details?.Product?.image} orderId={order?.invoice_no} items={order?.no_of_item} kwd={order?.total_amount}
                                                    footer_text={order?.Order_status?.name} date={order?.createdAt} order={order} /> */}
                      </div>

                      {/* <div className='return_main_div'>
                                                <div className='return_btn_div'>
                                                    <div className="">
                                                        <div className="text-center btn_holder">

                                                            <Tab.Container id="left-tabs-example" defaultActiveKey="return">

                                                                <Nav variant="pills" className="flex-row">
                                                                    <Nav.Item>
                                                                        <Nav.Link className='custom-outline-with-bg-btn' eventKey="return">Return</Nav.Link>
                                                                    </Nav.Item>
                                                                    <Nav.Item>
                                                                        <Nav.Link className='custom-outline-with-bg-btn ms-3' eventKey="replace">Replace</Nav.Link>
                                                                    </Nav.Item>
                                                                </Nav>

                                                                <Tab.Content>
                                                                    <Tab.Pane eventKey="return">
                                                                        <div onClick={() => { navigate("/return-repace-order") }}>
                                                                            <OrderCard

                                                                                title="ScanMart Grocery"
                                                                                img="/assets/images/profile/myaccount/img1.png"
                                                                                orderId="Order ID #675843"
                                                                                items="2 Items"
                                                                                kwd="Rs.: 200"
                                                                                footer_text="Scheduled to return"
                                                                                footer_text_color="#FD2121"
                                                                                date="27th Oct. | 03:28 pm"
                                                                                showtracking={true}
                                                                                trackingText="Order Return Tracking"
                                                                            />

                                                                            <OrderCard title="ScanMart Grocery" footer_text_color="#FD2121" img="/assets/images/profile/myaccount/img1.png" orderId="Order ID #675843" items="2 Items" kwd="Rs.: 200" footer_text="Scheduled to return" date="27th Oct. | 03:28 pm" />
                                                                        </div>
                                                                    </Tab.Pane>
                                                                    <Tab.Pane eventKey="replace">
                                                                        <div onClick={() => { navigate("/return-repace-order") }}>
                                                                            <OrderCard

                                                                                title="ScanMart Grocery"
                                                                                img="/assets/images/profile/myaccount/img1.png"
                                                                                orderId="Order ID #675843"
                                                                                items="2 Items"
                                                                                kwd="Rs.: 200"
                                                                                footer_text="Scheduled to return"
                                                                                footer_text_color="#FD2121"
                                                                                date="27th Oct. | 03:28 pm"
                                                                                showtracking={true}
                                                                                trackingText="Replacement Tracking"
                                                                            />

                                                                            <OrderCard title="ScanMart Grocery" footer_text_color="#FD2121" img="/assets/images/profile/myaccount/img1.png" orderId="Order ID #675843" items="2 Items" kwd="Rs.: 200" footer_text="Scheduled to return" date="27th Oct. | 03:28 pm" />
                                                                        </div>
                                                                    </Tab.Pane>
                                                                </Tab.Content>

                                                            </Tab.Container>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}

                      {/* <OrderCard
                                                title="ScanMart Grocery"
                                                img="/assets/images/profile/myaccount/img1.png"
                                                orderId="Order ID #675843"
                                                items="2 Items"
                                                kwd="Rs.: 200"
                                                footer_text="Cancelled on (15.JUL.24)"
                                                footer_text_color="#EC353A"
                                                date="27th Oct. | 03:28 pm"
                                                showtracking
                                                trackingText="Order Return Tracking"

                                            /> */}
                    </Tab.Pane>
                  </Tab.Content>

                  <div className="no_more_main_order_div ">
                    <div className="no_more_order_div">
                      <p>No more orders to show</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Tab.Container>
        </div>
      </div>
    </section>
  );
};

export default My_Orders;
